import { Component, Input, OnInit, Output, ViewChild, EventEmitter, model, signal, WritableSignal, Optional } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { CategorieEntite } from 'src/app/entites/categorie';
import { CategorieService } from 'src/app/services/categorie-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { EmplacementService } from 'src/app/services/emplacement-service';
import { Item } from 'src/app/entites/item';
import { SousCategorieService } from 'src/app/services/sous-categorie-service';
import { SousCategorieEntite } from 'src/app/entites/sousCategorie';
import { LocalisationEntrepotEntite } from 'src/app/entites/localisation-entrepot';
import { CompagnieEntite } from 'src/app/entites/compagnie';
import { Emplacement } from 'src/app/entites/emplacement';
import { TypeFacturationEntite } from 'src/app/entites/type-facturation';
import { ItemService } from 'src/app/services/item-service';
import { ItemMin } from 'src/app/entites/item-min';
import { HttpEventType } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-ajout-item',
  templateUrl: 'ajout-item.component.html',
  providers: [MessageService]
})
export class AjoutItemComponent implements OnInit {
  @ViewChild('champDescription') champDescription!: AutoComplete;
  @ViewChild('champNumero') champNumero: any;

  @Input() indLocation: boolean = false;
  @Input() submitted: boolean = false;



  private _item!: Item;

  @Input()
  get item(): Item {
    return this._item;
  }
  set item(value: Item) {
    this._item = new Proxy(value, {
      set: (target: any, prop: string, value: any) => {
        if (prop === 'numero') {
          if (this.indLocation) {
            value = this.ensureLocationPrefix(value);
          }
          this.isProchainDisabled = this.isNumberFormatValid(value);
        }
        target[prop] = value;
        if (prop == 'categorie' && this.listeSousCategories) {
          this.listeSousCategoriesFiltrees = this.listeSousCategories.filter(x => x.categorieId == value.categorieId);
        }
        this.itemChange.emit(this._item);
        return true;
      }
    });
    this.itemChange.emit(this._item);
  }

  @Output() itemChange = new EventEmitter<Item>();

  items: ItemMin[];
  marques: string[];
  produitDangereuxOptions: any[] = [
    { label: 'Oui', value: true },
    { label: 'Non', value: false }
  ];
  // Dropdown options
  listeCategories: CategorieEntite[];
  listeSousCategories: SousCategorieEntite[];
  listeSousCategoriesFiltrees: SousCategorieEntite[];
  listeCompagnies: CompagnieEntite[];
  emplacements: Emplacement[];
  listeLocalisations: LocalisationEntrepotEntite[];
  listeTypesFacturation: TypeFacturationEntite[];

  // Autocomplete suggestions
  suggestionDescription: string[] = [];
  suggestionMarque: string[] = [];

  // Add new property to track if the button should be disabled
  isProchainDisabled: boolean = false;
  existingNumero: string = null;
  loadingProchainNumero: boolean = false;

  loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
  loadingError: WritableSignal<string> = signal(null);

  constructor(
    private messageService: MessageService,
    private categorieService: CategorieService,
    private sousCategorieService: SousCategorieService,
    private donneesBaseService: DonneesBaseService,
    private emplacementsService: EmplacementService,
    private itemsService: ItemService,
    private sdb: DonneesBaseService,
    @Optional() private config: DynamicDialogConfig,
    @Optional() protected ref: DynamicDialogRef
  ) {
    if (this.config?.data) {
      this.item = this.config.data.item;
      console.log(this.item);
    }
  }

  ngOnInit() {
    this.chargerDonnees();
    if (this.indLocation && !this.item.numero) {
      this.item.numero = 'L';
    }
  }

  private chargerDonnees() {
    this.categorieService.ObtenirListe().then(categories => {
      if (categories.estUnSucces) {
        this.listeCategories = categories.valeur;
        this.item.categorie = this.listeCategories.find(x => x.categorieId == this.item.categorie?.categorieId);
      } else {
        categories.messages.forEach(message => {
          this.messageService.add({
            severity: message.severity,
            summary: message.code,
            detail: message.description
          });
        });
      }
    });

    this.sousCategorieService.ObtenirListe().then(sousCategories => {
      if (sousCategories.estUnSucces) {
        this.listeSousCategories = sousCategories.valeur;
        this.listeSousCategoriesFiltrees = this.listeSousCategories.filter(x => x.categorieId == this.item.categorie?.categorieId);
        this.item.sousCategorie = this.listeSousCategories.find(x => x.sousCategorieId == this.item.sousCategorie?.sousCategorieId);
      } else {
        sousCategories.messages.forEach(message => {
          this.messageService.add({
            severity: message.severity,
            summary: message.code,
            detail: message.description
          });
        });
      }
    });

    this.listeCompagnies = this.donneesBaseService.Compagnies();
    this.item.compagnie = this.listeCompagnies.find(x => x.compagnieId == this.item.compagnie?.compagnieId);

    this.listeTypesFacturation = this.donneesBaseService.TypesFacturation();

    this.listeLocalisations = this.donneesBaseService.LocalisationsEntrepot();

    this.emplacementsService.Obtenir().then(emplacements => {
      if (emplacements.estUnSucces) {
        this.emplacements = emplacements.valeur;
        this.item.emplacement = this.emplacements.find(x => x.emplacementId == 10000);
      } else {
        emplacements.messages.forEach(message => {
          this.messageService.add({
            severity: message.severity,
            summary: message.code,
            detail: message.description
          });
        });
      }
    });

    this.itemsService.ObtenirItems(null).subscribe({
      next: (x) => {
        if (x.type == HttpEventType.Response) {
          this.items = x.body.value();
        }
        this.loadingEvent.set(x);
      },
      error: (error) => {
        this.loadingError.set(error.error);
      }
    });

    this.marques = this.sdb.Marques();
  }

  surSelectionCategorie() {
    // Reset related fields
    this.item.sousCategorie = null;
    this.listeSousCategories = [];
    // Fetch sub-categories based on selected category
  }

  surChangementSousCategorie(event: any) {
    this.sousCategorieService.ObtenirPrefixParSousCategorie(event.value.sousCategorieId).subscribe({
      next: (x) => {
        if (x.body != null) {
          let prefix = x.body + '-';
          if (this.indLocation) {
            prefix = 'L' + prefix;
          }
          this.item.numero = prefix;
          this.obtenirProchainNumero();
        }
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  private ensureLocationPrefix(numero: string): string {
    if (!numero) return this.indLocation ? 'L' : '';
    if (this.indLocation && !numero.startsWith('L')) {
      return 'L' + numero;
    }
    return numero;
  }

  // Add new method to check number format
  private isNumberFormatValid(numero: string): boolean {
    if (!numero) return false;
    // Match pattern: any letters/numbers, followed by hyphen, followed by numbers
    const pattern = /^[a-zA-Z0-9]+-\d+$/;
    return pattern.test(numero);
  }

  obtenirProchainNumero() {
    this.loadingProchainNumero = true;
    if (this.item.numero.length > 0 && !this.isProchainDisabled) {
      this.itemsService.ObtenirProchainNumero(this.item.numero).then(x => {
        let newNumero = this.item.numero + x.valeur;
        if (this.indLocation) {
          newNumero = this.ensureLocationPrefix(newNumero);
        }
        this.item.numero = newNumero;
        this.itemChange.emit(this.item);
        // Check format after setting new number
        this.isProchainDisabled = this.isNumberFormatValid(this.item.numero);
      }).finally(() => {
        this.loadingProchainNumero = false;
      });
    } else {
      this.loadingProchainNumero = false;
    }
  }

  rechercherDescription(event: any) {
    this.suggestionDescription = this.items.filter(x => this.item.description.localeCompare(x.description.substring(0, this.item.description.length), 'en', { sensitivity: 'base' }) == 0).map(x => x.description);
  }

  rechercherMarque(event: any) {
    this.suggestionMarque = this.marques.filter(x => this.item.marque.localeCompare(x.substring(0, this.item.marque.length), 'en', { sensitivity: 'base' }) == 0);
  }

  onClose() {
    this.ref.close(null);
  }

  onSubmit() {
    this.enregistrer();
  }

  enregistrer() {

    this.submitted = true;

    if (!this.valider()) {
      this.messageService.add({ severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
      return;
    }

    this.itemsService.CreerItem(this.item).then(x => {
      if (x.estUnSucces) {
        this.ref.close(x.valeur);
      } else {
        x.messages.forEach(x => {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
        });
      }
    });
  }

  valider() {
    if (!this.item.categorie) {
      return false;
    }
    return true;
  }
}
